import React from 'react';
import { Link, Redirect } from 'react-router-dom';

import add_student from '../../content/images/add-student.png';
import extend from '../../content/images/extend.png'

class Choose extends React.Component {

    constructor(props) {
        super(props);
        this.state = {
            redirect: null,
            loggedIn: true, //todo: get from a central source
            hasSubscription: true //todo: get from a central source
        }
    }

    render() {

        if (this.state.redirect) {
            return <Redirect to={this.state.redirect} />
        }

        if (!this.state.loggedIn || !this.state.hasSubscription) {
            this.setState({
                redirect: "/subscribe"
            });
        }

        return (
            <React.Fragment>
                <h1>Manage Subscriptions</h1>
                <p>You have existing subscription(s), would like you to extend a subscription's duration or add more students to a subscription?</p>
                
                <div className="row">
                    <div class="col-md-5 offset-md-1 col-sm-4 offset-sm-2 offset-0">
                        <Link to="/subscribe/extend/summary">
                            <div class="btn btn-secondary btn-lg col-md-12" type="submit">
                                <img class="img-fluid center-block" src={extend} />
                                <h3>Extend Subscriptions</h3>
                            </div>
                        </Link>
                    </div>

                    <div class="col-md-5 offset-md-0 col-sm-4 offset-sm-0 offset-0">
                        <Link to="/subscribe/add">
                            <div class="btn btn-secondary btn-lg">
                                <img class="img-fluid center-block" src={add_student} />
                                <h3>Add Students</h3>
                            </div>
                        </Link>
                    </div>
                </div>
            </React.Fragment>
        )
    }

}

export default Choose;
